export const DEFAULT_STATIC_MAP_HEIGHT = 194;

export const DEFAULT_STATIC_MAP_WIDTH = 1000;

export const ADDRESS_CARD_MIN_HEIGHT = 380;

export const ADDRESS_CARD_SX = {
  flexGrow: 1,
  display: 'flex',
  minHeight: ADDRESS_CARD_MIN_HEIGHT,
} as const;

export const ADDRESS_CARD_SIZE = {
  lg: 3,
  md: 4,
  xs: 12,
} as const;
